import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-save-card-failed-mb',
  templateUrl: './save-card-failed-mb.component.html',
  styleUrls: ['./save-card-failed-mb.component.scss']
})
export class SaveCardFailedMbComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
